'use client';

import cn from 'classnames';
import { forwardRef } from 'react';

import { useAnalytics } from '@/hooks/useAnalytics';
import { ClickAnalyticsType } from '@/types';

import s from './Button.module.scss';

interface ButtonProps {
  tagElement?: 'span' | 'button';
  children: React.ReactNode;
  className?: string;
  variant?: 'primary';
  onClick?(): void;
  isLoading?: boolean;
  isDisabled?: boolean;
  withSlashes?: boolean;
  type?: 'button' | 'submit';
  analyticsOptions: ClickAnalyticsType;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type = 'button',
      className = '',
      children,
      onClick,
      isLoading = false,
      withSlashes = true,
      isDisabled = false,
      tagElement = 'span',
      analyticsOptions,
    },
    ref,
  ) => {
    const { clickAnalytics } = useAnalytics();

    const onButtonClick = () => {
      if (!isLoading && !isDisabled && onClick) {
        clickAnalytics(analyticsOptions);
        onClick();
      }
    };

    const TagElement = tagElement;

    return (
      <TagElement
        className={cn(s.root, className, {
          [s.disabled]: !!isDisabled,
        })}
        onClick={onButtonClick}
        disabled={isDisabled}
        type={type}
        ref={ref}
      >
        {children}
        {withSlashes && <span dangerouslySetInnerHTML={{ __html: '//' }} />}
      </TagElement>
    );
  },
);

Button.displayName = 'Button';

export { Button };
